cb.define(['common/common_VM.Extend.js'], function (common) {
    //String转换Int（位运算）
    var setCheckBoxEnum = function (data) {

        if (data != undefined) {
            var oldData = data.split(",");
            var result = 0;
            if (oldData != "") {
                oldData.forEach(function (item, index) {
                    result += Math.pow(2, parseInt(item) - 1);
                });
            }
            return result;
        } else {
            return 0;
        }

    };

    var PM_pmc_jewelrygiftpromotion_VM_Extend = {
        doAction: function (name, viewmodel) {
            if (this[name])
                this[name](viewmodel);
        },

        init: function (viewmodel) {

            // itemtype{
            //     1:总额;
            //     2:工费;
            //     3:金额;
            //     4:免工费;
            //     5:送工费;
            //     6:送克数;
            //     7:送赠品;
            //     8:送积分;
            //     9:送优惠券
            // }

            let mode = viewmodel.getParams().mode;
            var nowDates = new Date().format('yyyy-MM-dd hh:mm:ss');
            var user = cb.rest.AppContext.user;

            const PointStypePromotionArray =
                [{"value": "1", "text": "减价", "nameType": "text"},
                    {"value": "2", "text": "打折", "nameType": "text"},
                    {"value": "3", "text": "一口价", "nameType": "text"}];

            const PointStypeIntegralArray =
                [{"value": "1", "text": "N倍积分", "nameType": "text"},
                    {"value": "2", "text": "固定积分", "nameType": "text"}];

            const PointStypeProArray =
                [{"value": "1", "text": "全部商品", "nameType": "text"},
                    {"value": "2", "text": "参与活动商品", "nameType": "text"},
                    {"value": "3", "text": "指定商品分类", "nameType": "text"},
                    {"value": "4", "text": "指定款式", "nameType": "text"},
                    {"value": "5", "text": "指定货品", "nameType": "text"},
                    {"value": "6", "text": "指定标签", "nameType": "text"}];

            const iTemtypeArray =
                [{"value": "1", "text": "总额", "nameType": "text"},
                    {"value": "2", "text": "工费", "nameType": "text"},
                    {"value": "3", "text": "金价", "nameType": "text"},
                    {"value": "4", "text": "免工费", "nameType": "text"},
                    {"value": "5", "text": "送工费", "nameType": "text"},
                    {"value": "6", "text": "送克数", "nameType": "text"},
                    {"value": "7", "text": "送赠品", "nameType": "text"},
                    {"value": "8", "text": "送积分", "nameType": "text"},
                    {"value": "9", "text": "送优惠券", "nameType": "text"}];

            const displayReferType = (editRowModels, value) => {
                var refCode = "";
                var refRetId = "";
                //3商品分类 4 商品 5 商品SKU 6 商品标签 7 优惠券
                let valueField = '';
                if (value == 3) {
                    refCode = "pc_presentationclassref";
                    refRetId = '{"cGiftIds":"id","cGiftNames":"name"}';
                    valueField = 'name';
                } else if (value == 4) {
                    refCode = "pmc_product";
                    refRetId = '{"cGiftIds":"id","cGiftNames":"cName"}';
                    valueField = 'cName';
                } else if (value == 5) {
                    refCode = "aa_productsku";
                    refRetId = '{"cGiftIds":"productskus_id","cGiftNames":"name"}';
                    valueField = 'name';
                } else if (value == 6) {
                    refCode = "pc_tagref";
                    refRetId = '{"cGiftIds":"id","cGiftNames":"name"}';
                    valueField = 'name';
                } //else if (value == 7) {
                //     refCode = "pmc_couponref";
                //     refRetId = '{"cGiftIds":"id","cGiftNames":"name"}';
                //     valueField = 'name';
                // }
                if (refCode) {
                    editRowModels.get("cGiftNames").setRefCode(refCode, refRetId);
                    editRowModels.get("cGiftNames").setRefReturn(valueField);
                    editRowModels.get("cGiftNames").setState('valueField', valueField);
                }
            }

            const displayMemberLevelAll = () => {
                if (viewmodel.get('iMemberLevelAll').getValue() == 0) {
                    viewmodel.get('jewelryGiftPromotionMemberLevel').setVisible(true);
                } else {
                    viewmodel.get('jewelryGiftPromotionMemberLevel').setVisible(false);
                }
            }
            const displayApplyStoreType = () => {
                if (viewmodel.get('iApplyStoreType').getValue() == 1) {
                    viewmodel.get('jewelryGiftPromotionStore').setVisible(false);
                } else {
                    viewmodel.get('jewelryGiftPromotionStore').setVisible(true);
                }
            }

            const delPro = () => {
                if (viewmodel.get('jewelryGiftProduct').getRows() && viewmodel.get('jewelryGiftProduct').getRows().length > 0) {
                    let pricenums = viewmodel.get('jewelryGiftProduct').getRowsCount();
                    for (let i = pricenums - 1; i >= 0; i--) {
                        viewmodel.get('jewelryGiftProduct').deleteRows(i);
                    }
                }
            }
            const delClass = () => {
                if (viewmodel.get('jeweActiveProductClass').getShowValue() && viewmodel.get('jeweActiveProductClass').getShowValue().length > 0) {
                    viewmodel.get('jeweActiveProductClass').setValue([]);
                }
            }
            const delTag = () => {
                if (viewmodel.get('jewelryProductTag').getShowValue() && viewmodel.get('jewelryProductTag').getShowValue().length > 0) {
                    viewmodel.get('jewelryProductTag').setValue([]);
                }
            }

            const delItemGift = (editRowModel) => {
                // editRowModel.get('cGiftNums').setValue(null, true);
                editRowModel.get('cGiftNames').setValue(null, true);
                editRowModel.get('givenum').setValue(null, true);
            }

            const displayProReferType = (value) => {
                var refCode = "";
                var refRetId = "";
                // 2 商品 3 商品sku
                if (value == 2) {
                    viewmodel.get("jewelryGiftProduct").setColumnState("skuDescription", "bShowIt", false);
                    viewmodel.get("jewelryGiftProduct").setColumnState("cName", "cShowCaption", "商品名称");
                    refCode = "pmc_product";
                    refRetId = '{"iproductId":"id","cName":"cName","fSalePrice":"fSalePrice","fmarketPrice":"fMarkPrice","imageUrl":"url"}';
                } else if (value == 3) {
                    viewmodel.get("jewelryGiftProduct").setColumnState("skuDescription", "bShowIt", true);
                    viewmodel.get("jewelryGiftProduct").setColumnState("cName", "cShowCaption", "商品SKU");
                    refCode = "aa_productsku";
                    refRetId = ' {"iproductId":"productskus_id","cName":"name","fSalePrice":"fSalePrice","fmarketPrice":"fMarkPrice","imageUrl":"url","skuDescription":"specs"}';
                }
                if (refCode) {
                    viewmodel.get("jewelryGiftProduct").getEditRowModel().get("cName").setRefCode(refCode, refRetId);
                }
            }

            const displayiActiveiDimension = (deletePro) => {
                if (viewmodel.get('iActiveiDimension').getValue() == 1) {
                    viewmodel.execute('updateViewMeta', {
                        code: 'goodstab',
                        visible: false
                    });
                    viewmodel.get('jewelryGiftProduct').setColumnState('cName', 'bIsNull', true);
                    viewmodel.get('btnBatchOp').setVisible(false);
                    viewmodel.get('btnAddRow').setVisible(false);
                    viewmodel.get('jeweActiveProductClass').setVisible(true);
                    viewmodel.get('jewelryProductTag').setVisible(false);
                    delPro();
                    delTag();
                } else if (viewmodel.get('iActiveiDimension').getValue() == 2) {
                    viewmodel.execute('updateViewMeta', {
                        code: 'goodstab',
                        visible: true
                    });
                    viewmodel.get('jewelryGiftProduct').setColumnState('cName', 'bIsNull', false);
                    if (mode != 'browse') {
                        viewmodel.get('btnBatchOp').setVisible(true);
                        viewmodel.get('btnAddRow').setVisible(true);
                    }
                    viewmodel.get('jeweActiveProductClass').setVisible(false);
                    viewmodel.get('jewelryProductTag').setVisible(false);
                    displayProReferType(viewmodel.get('iActiveiDimension').getValue());
                    delClass();
                    if (deletePro) {
                        delPro();
                    }
                    delTag();
                } else if (viewmodel.get('iActiveiDimension').getValue() == 3) {
                    viewmodel.execute('updateViewMeta', {
                        code: 'goodstab',
                        visible: true
                    });
                    viewmodel.get('jewelryGiftProduct').setColumnState('cName', 'bIsNull', false);
                    if (mode != 'browse') {
                        viewmodel.get('btnBatchOp').setVisible(true);
                        viewmodel.get('btnAddRow').setVisible(true);
                    }
                    viewmodel.get('jeweActiveProductClass').setVisible(false);
                    viewmodel.get('jewelryProductTag').setVisible(false);
                    displayProReferType(viewmodel.get('iActiveiDimension').getValue());
                    delClass();
                    if (deletePro) {
                        delPro();
                    }
                    delTag();
                } else {
                    viewmodel.execute('updateViewMeta', {
                        code: 'goodstab',
                        visible: false
                    });
                    viewmodel.get('jewelryGiftProduct').setColumnState('cName', 'bIsNull', true);
                    viewmodel.get('btnBatchOp').setVisible(false);
                    viewmodel.get('btnAddRow').setVisible(false);
                    viewmodel.get('jeweActiveProductClass').setVisible(false);
                    viewmodel.get('jewelryProductTag').setVisible(true);
                    delPro();
                    delClass();
                }

            }
            const displayiActivityRange = (deletePro) => {
                if (viewmodel.get('iActivityRange').getValue() == 0) {
                    viewmodel.get('iActiveiDimension').setVisible(false);
                    viewmodel.get('iActiveiDimension').setValue(1);
                    viewmodel.execute('updateViewMeta', {
                        code: 'goodstab',
                        visible: false
                    });
                    viewmodel.get('jewelryGiftProduct').setColumnState('cName', 'bIsNull', true);
                    viewmodel.get('btnBatchOp').setVisible(false);
                    viewmodel.get('btnAddRow').setVisible(false);
                    viewmodel.get('jeweActiveProductClass').setVisible(false);
                    viewmodel.get('jewelryProductTag').setVisible(false);
                    delPro();
                    delClass();
                    delTag();
                } else {
                    viewmodel.get('iActiveiDimension').setVisible(true);
                    displayiActiveiDimension(deletePro);
                }
            }
            const displayisShare = () => {
                let isShare = viewmodel.get('isShare').getValue();
                if (isShare == 0) {
                    viewmodel.get('isTakeInShare').setDisabled(true);
                    viewmodel.get('isTakeInShare').setValue(0);
                } else {
                    viewmodel.get('isTakeInShare').setDisabled(false);
                }
            }

            const hiddenFieldGPA = (editRowModels) => {
                editRowModels.get('goldg').setVisible(false);
                editRowModels.get('pointstype').setVisible(false);
                editRowModels.get('addprice').setVisible(false);
            }

            const hiddenFieldcCFDG = (editRowModels) => {
                editRowModels.get('cGiftNames').setVisible(false);
                editRowModels.get('fireNum').setVisible(false);
                editRowModels.get('discountNum').setVisible(false);
                editRowModels.get('givenum').setVisible(false);
            }
            const displayField = (editRowModels, fieldList) => {
                fieldList.forEach(function (field) {
                    editRowModels.get(field).setVisible(true);
                });
            }

            const controlDecimal = (editRowModels) => {
                editRowModels.get('consumerPrice').setState('min', 0);
                editRowModels.get('consumerSpending').setState('min', 0);
                editRowModels.get('goldg').setState('min', 0);
                editRowModels.get('addprice').setState('min', 0);
                editRowModels.get('fireNum').setState('min', 0);
                editRowModels.get('discountNum').setState('min', 0);
                editRowModels.get('givenum').setState('min', 0);
            }


            const displayitemtype = (editRowModels, rowIndex, initialization) => {
                editRowModels.get('givenum').setDisabled(false);
                let itemtype = viewmodel.get('jewelryGiftPromotionItem').getCellValue(rowIndex, 'itemtype');
                let pointstype = viewmodel.get('jewelryGiftPromotionItem').getCellValue(rowIndex, 'pointstype');
                let auditStatusModel = editRowModels.get('pointstype');
                let newSource = [];
                let fieldList = new Array();
                hiddenFieldGPA(editRowModels);
                hiddenFieldcCFDG(editRowModels);
                //送克数 6 送赠品 7 送优惠券 9
                if (itemtype == 1 || itemtype == 2) {
                    PointStypePromotionArray && PointStypePromotionArray.forEach(data => {
                        if (data.value != 3) {
                            newSource.push({value: data.value, nameType: 'text', text: data.text});
                        }
                    });
                    auditStatusModel.setDataSource(newSource);
                    if (initialization) {
                        if (pointstype == 1) {
                            fieldList.push('pointstype', 'fireNum');
                            displayField(editRowModels, fieldList);
                        } else {
                            fieldList.push('pointstype', 'discountNum');
                            displayField(editRowModels, fieldList);
                        }
                    } else {
                        editRowModels.get('pointstype').setValue(1, true);
                        fieldList.push('pointstype', 'fireNum');
                        displayField(editRowModels, fieldList);
                    }
                } else if (itemtype == 3) {
                    auditStatusModel.setDataSource(PointStypePromotionArray);
                    if (initialization) {
                        if (pointstype == 1) {
                            fieldList.push('goldg', 'pointstype', 'fireNum');
                            displayField(editRowModels, fieldList);
                        } else if (pointstype == 2) {
                            fieldList.push('goldg', 'pointstype', 'discountNum');
                            displayField(editRowModels, fieldList);
                        } else {
                            fieldList.push('goldg', 'pointstype', 'givenum');
                            displayField(editRowModels, fieldList);
                            editRowModels.get('givenum').setState('cShowCaption', '');
                            editRowModels.get('givenum').setState('after', '');
                        }
                    } else {
                        editRowModels.get('pointstype').setValue(1, true);
                        fieldList.push('goldg', 'pointstype', 'fireNum');
                        displayField(editRowModels, fieldList);
                    }
                } else if (itemtype == 5) {
                    fieldList.push('addprice', 'givenum');
                    displayField(editRowModels, fieldList);
                    editRowModels.get('givenum').setState('cShowCaption', '送工费');
                    editRowModels.get('givenum').setState('after', '克/件');
                } else if (itemtype == 6) {
                    editRowModels.get('cGiftNames').setState('checkValid', true);
                    editRowModels.get('cGiftNames').setState('selfDefineClick', null);
                    editRowModels.get('givenum').setState('cShowCaption', '送');
                    editRowModels.get('givenum').setState('after', '克');
                    auditStatusModel.setDataSource(PointStypeProArray);
                    if (initialization) {
                        if (pointstype == 1 || pointstype == 2) {
                            fieldList.push('pointstype', 'addprice', 'givenum');
                            displayField(editRowModels, fieldList);
                        } else {
                            fieldList.push('pointstype', 'addprice', 'cGiftNames', 'givenum');
                            displayField(editRowModels, fieldList);
                            displayReferType(editRowModels, pointstype);
                        }
                    } else {
                        editRowModels.get('pointstype').setValue(1, true);
                        fieldList.push('pointstype', 'addprice', 'givenum');
                        displayField(editRowModels, fieldList);
                    }
                } else if (itemtype == 7) {
                    editRowModels.get('cGiftNames').setState('checkValid', true);
                    editRowModels.get('cGiftNames').setState('selfDefineClick', null);
                    editRowModels.get('givenum').setState('cShowCaption', '送赠品');
                    editRowModels.get('givenum').setState('after', '件');
                    auditStatusModel.setDataSource(PointStypeProArray);
                    if (initialization) {
                        if (pointstype == 1 || pointstype == 2) {
                            fieldList.push('pointstype', 'addprice', 'givenum');
                            displayField(editRowModels, fieldList);
                        } else {
                            fieldList.push('pointstype', 'addprice', 'cGiftNames', 'givenum');
                            displayField(editRowModels, fieldList);
                            displayReferType(editRowModels, pointstype);
                        }
                    } else {
                        editRowModels.get('pointstype').setValue(1, true);
                        fieldList.push('pointstype', 'addprice', 'givenum');
                        displayField(editRowModels, fieldList);
                    }
                } else if (itemtype == 8) {
                    fieldList.push('pointstype', 'givenum');
                    displayField(editRowModels, fieldList);
                    auditStatusModel.setDataSource(PointStypeIntegralArray);
                    if (initialization) {
                        if (pointstype == 1) {
                            editRowModels.get('givenum').setState('cShowCaption', '');
                            editRowModels.get('givenum').setState('after', '倍');
                        } else {
                            editRowModels.get('givenum').setState('cShowCaption', '');
                            editRowModels.get('givenum').setState('after', '积分');
                        }
                    } else {
                        editRowModels.get('pointstype').setValue(1, true);
                        editRowModels.get('givenum').setState('cShowCaption', '');
                        editRowModels.get('givenum').setState('after', '倍');
                    }
                } else if (itemtype == 9) {
                    editRowModels.get('cGiftNames').setState('checkValid', false);
                    fieldList.push('cGiftNames', 'givenum');
                    displayField(editRowModels, fieldList);
                    editRowModels.get('givenum').setState('cShowCaption', '');
                    editRowModels.get('givenum').setState('after', '张');
                    editRowModels.get('givenum').setDisabled(true);
                    // displayReferType(editRowModels, 7);
                    editRowModels.get('cGiftNames').setState('selfDefineClick', function () {
                        debugger;
                        var data = {
                            billtype: 'VoucherList',
                            billno: 'pmc_couponref',
                            params: {
                                couponids: "",
                                couponnames: "",
                                couponnums: ""
                            }
                        };
                        if (editRowModels.get('cGiftIds').getValue() && editRowModels.get('cGiftNames').getValue()
                            && editRowModels.get('cGiftNames').getValue() != "") {
                            data.params["couponids"] = editRowModels.get('cGiftIds').getValue();
                            data.params["couponnames"] = editRowModels.get('cGiftNames').getValue();
                            data.params["couponnums"] = editRowModels.get('cGiftNums').getValue();
                        }
                        cb.loader.runCommandLine('bill', data, viewmodel, (vm) => {
                            vm.on('sure1', function (data) {
                                if (editRowModels) {
                                    if (data && data.length > 0) {
                                        let couponids = "";
                                        let couponnames = "";
                                        let couponnums = "";
                                        let amountTotal = 0;
                                        for (let i = 0; i < data.length; i++) {
                                            //勾选了但是数量为0的不添加
                                            if (data[i].amount && data[i].amount != "0" && data[i].id && data[i].name) {
                                                if (couponids != '') {
                                                    couponids += "," + data[i].id;
                                                } else {
                                                    couponids += data[i].id;
                                                }

                                                if (couponnames != '') {
                                                    couponnames += "," + data[i].name;
                                                } else {
                                                    couponnames += data[i].name;
                                                }

                                                if (couponnums != '') {
                                                    couponnums += "," + data[i].amount;
                                                } else {
                                                    couponnums += data[i].amount;
                                                }
                                                amountTotal += parseInt(data[i].amount);
                                            }
                                        }
                                        editRowModels.get('cGiftIds').setValue(couponids, true);
                                        editRowModels.get('cGiftNames').setValue(couponnames, true);
                                        editRowModels.get('cGiftNums').setValue(couponnums, true);
                                        editRowModels.get('givenum').setValue(amountTotal, true);
                                    }
                                }
                                vm.execute('close');
                            });
                            vm.on('promotionabandon', function () {
                                vm.execute('close');
                            });

                            vm.on('close', function () {
                                viewmodel.communication({
                                    type: 'modal',
                                    payload: {
                                        data: false
                                    }
                                })
                            })
                            return true;
                        })
                    })
                }
            }

            const displaypointstype = (editRowModels, pointstype, itemtype, fieldList) => {
                hiddenFieldcCFDG(editRowModels);
                displayField(editRowModels, fieldList);
                if (itemtype == 6 || itemtype == 7) {
                    if (pointstype != 1 && pointstype != 2) {
                        displayReferType(editRowModels, pointstype);
                    }
                    if (itemtype == 6) {
                        editRowModels.get('givenum').setState('cShowCaption', '送');
                        editRowModels.get('givenum').setState('after', '克');
                    } else {
                        editRowModels.get('givenum').setState('cShowCaption', '送赠品');
                        editRowModels.get('givenum').setState('after', '件');
                    }
                } else if (itemtype == 8) {
                    if (pointstype == 1) {
                        editRowModels.get('givenum').setState('after', '倍');
                    } else {
                        editRowModels.get('givenum').setState('after', '积分');
                    }
                } else if (itemtype == 3) {
                    editRowModels.get('givenum').setState('cShowCaption', '');
                    editRowModels.get('givenum').setState('after', '');
                }
            }

            const displayCapping = (editRowModels, i) => {
                if (editRowModels.length > 0 && i >= 0) {
                    if (i < editRowModels.length - 1) {
                        if (editRowModels[i].get('isCapping').getValue() == "1") {
                            editRowModels[i].get('isCapping').setValue(0, true);
                        }
                        editRowModels[i].get('isCapping').setDisabled(true);
                    } else if (i == editRowModels.length - 1) {
                        editRowModels[editRowModels.length - 1].get('isCapping').setDisabled(false);
                    }
                }
            }

            viewmodel.get("jewelryGiftPromotionItem").on('afterCellValueChange', function (args) {
                let fieldList = new Array();
                let editRowModels = viewmodel.get('jewelryGiftPromotionItem').getCache('editRowModels')[args.rowIndex];
                let itemtype = viewmodel.get('jewelryGiftPromotionItem').getCellValue(args.rowIndex, 'itemtype');
                let pointstype = viewmodel.get('jewelryGiftPromotionItem').getCellValue(args.rowIndex, 'pointstype');
                if (args.cellName == 'pointstype') {
                    if (itemtype == 1 || itemtype == 2 || itemtype == 3) {
                        if (pointstype == 1) {
                            fieldList.push('fireNum');
                        } else if (pointstype == 2) {
                            fieldList.push('discountNum');
                        } else if (pointstype == 3) {
                            fieldList.push('givenum');
                        }
                    } else if (itemtype == 6 || itemtype == 7) {
                        if (pointstype != 1 && pointstype != 2) {
                            fieldList.push('cGiftNames', 'givenum');
                        } else {
                            fieldList.push('givenum');
                        }
                    } else if (itemtype == 8) {
                        fieldList.push('givenum');
                    }
                    displaypointstype(editRowModels, pointstype, itemtype, fieldList);
                    delItemGift(editRowModels);
                } else if (args.cellName == 'itemtype') {
                    displayitemtype(editRowModels, args.rowIndex, false);
                    delItemGift(editRowModels);
                } else if (args.cellName == 'consumerPrice' || args.cellName == 'consumerSpending') {
                    if (cb.utils.isEmpty(args.value)) {
                        editRowModels.get(args.cellName).setValue(0, true);
                    }
                }
            });

            viewmodel.get("jewelryGiftPromotionItem").on('beforeInsertRowsFromRefer', function (data) {
                if (data.rows) {
                    let row = {};
                    let nameKey = "cGiftNames";
                    let idKey = "cGiftIds";
                    row[idKey] = "";
                    row[nameKey] = "";
                    for (let i = 0; i < data.rows.length; i++) {
                        if (data.rows[i][idKey] && data.rows[i][idKey] != "") {
                            row[idKey] += data.rows[i][idKey];
                            if (i != data.rows.length - 1)
                                row[idKey] += ",";
                        }
                        if (data.rows[i][nameKey] && data.rows[i][nameKey] != "") {
                            row[nameKey] += data.rows[i][nameKey];
                            if (i != data.rows.length - 1)
                                row[nameKey] += ",";
                        }
                    }
                    data.rows.length = 0;
                    data.rows.push(row);
                }
            })

            viewmodel.get("jewelryGiftPromotionItem").on('beforeBrowse', function (data) {
                let item = viewmodel.get('jewelryGiftPromotionItem').getRows()[data.rowIndex];
                let itemtype = item.itemtype;
                let pointstype = item.pointstype;
                let cGiftIds = item.cGiftIds;
                //送克数 6 送赠品 7
                if (itemtype == 7 || itemtype == 6) {
                    //3 分类 4 商品 5 sku 6 标签
                    if (pointstype == 3 || pointstype == 4 || pointstype == 5 || pointstype == 6) {
                        let fieldName = "";
                        let condition = {
                            "isExtend": true,
                            simpleVOs: []
                        };
                        let exitIds = [];
                        if (cGiftIds && cGiftIds != '') {
                            exitIds = cGiftIds.split(",");
                            condition.simpleVOs.push({
                                field: 'id',
                                op: 'in',
                                value1: exitIds
                            });
                        }
                        if (pointstype == 4 || pointstype == 5) {
                            if (pointstype == 5) {
                                fieldName = "productId.";
                            }
                            if (user && user.iShopId) {
                                condition.simpleVOs.push({
                                    field: fieldName + 'productApplyRange.shopId',
                                    op: 'eq',
                                    value1: user.iShopId
                                });
                            } else {
                                condition.simpleVOs.push({
                                    field: fieldName + 'productApplyRange.isCreator',
                                    op: 'eq',
                                    value1: 1
                                });
                            }
                            condition.simpleVOs.push({
                                field: fieldName + 'saleStyle',
                                op: 'eq',
                                value1: 1
                            });
                            data.context.setFilter(condition);
                        } else if (pointstype == 3) {
                            // data.context.setData(null);
                            data.context.setTreeFilter(condition);
                        } else if (pointstype == 6) {
                            data.context.setFilter(condition);
                        }
                        // data.context.setFilter(condition);
                    } else {
                        data.context.setFilter(null);
                    }
                    // data.context.setData(null);可以清空likevalue
                }
            })

            viewmodel.get("jewelryGiftProduct").on('beforeBrowse', function (data) {
                //1商品分类 2 商品 3 商品sku 4 商品标签
                let type = viewmodel.get('iActiveiDimension').getValue();
                let condition = {
                    "isExtend": true,
                    simpleVOs: []
                };
                let itemList = viewmodel.get("jewelryGiftProduct").getRows();
                let exitIds = [];
                if (itemList) {
                    let key = 'iproductId';
                    for (let i = 0; i < itemList.length; i++) {
                        if (itemList[i][key] && itemList[i][key] != '') {
                            exitIds.push(itemList[i][key]);
                        }
                    }
                    condition.simpleVOs.push({
                        field: 'id',
                        op: 'nin',
                        value1: exitIds
                    });
                }
                if (type == 2 || type == 3) {
                    let fieldName = (type == 2 ? "" : 'productId.');
                    if (user && user.iShopId) {
                        condition.simpleVOs.push({
                            field: fieldName + 'productApplyRange.shopId',
                            op: 'eq',
                            value1: user.iShopId
                        });
                    } else {
                        condition.simpleVOs.push({
                            field: fieldName + 'productApplyRange.isCreator',
                            op: 'eq',
                            value1: 1
                        });
                    }
                    condition.simpleVOs.push({
                        field: fieldName + 'saleStyle',
                        op: 'eq',
                        value1: 1
                    });
                }
                data.context.setFilter(condition);
            })

            viewmodel.get('isShare').on("afterValueChange", function (data) {
                displayisShare();
            })

            viewmodel.get("iMemberLevelAll").on('afterValueChange', () => {
                displayMemberLevelAll();
            })

            viewmodel.get("iApplyStoreType").on('afterValueChange', () => {
                displayApplyStoreType();
            })

            viewmodel.get("iActivityRange").on('afterValueChange', () => {
                displayiActivityRange(true);
            })

            viewmodel.get("iActiveiDimension").on('afterValueChange', () => {
                displayiActiveiDimension(true);
            })

            viewmodel.get("iPromotionalType").on('afterValueChange', () => {
                let counts = viewmodel.get('jewelryGiftPromotionItem').getRowsCount();
                var rowIndexes = [];
                for (let i = counts - 1; i >= 0; i--) {
                    rowIndexes.push(i);
                }
                viewmodel.get("jewelryGiftPromotionItem").deleteRows(rowIndexes);
                setTimeout(() => {
                    viewmodel.get('jewelryGiftPromotionItem').appendRow({});
                    let auditStatusModel = viewmodel.get('jewelryGiftPromotionItem').getCache('editRowModels')[0].get('itemtype');
                    if (viewmodel.get('iPromotionalType').getValue() == 1) {
                        let newSource = [];
                        iTemtypeArray && iTemtypeArray.forEach(data => {
                            if (data.value == 1 || data.value == 6 || data.value == 7 || data.value == 8 || data.value == 9) {
                                newSource.push({value: data.value, nameType: 'text', text: data.text});
                            }
                        });
                        auditStatusModel.setDataSource(newSource);
                    } else {
                        auditStatusModel.setDataSource(iTemtypeArray);
                    }
                }, 0);
            })

            viewmodel.get("jewelryGiftPromotionItem").on('afterInsertRow', function (args) {
                let editRowModels = viewmodel.get('jewelryGiftPromotionItem').getCache('editRowModels');
                displayitemtype(editRowModels[args.index], args.index, false);
                controlDecimal(editRowModels[args.index]);
                for (let i = 0; i < editRowModels.length; i++) {
                    displayCapping(editRowModels, i);
                }
            });

            viewmodel.get("jewelryGiftPromotionItem").on('afterDeleteRows', function (args) {
                let editRowModels = viewmodel.get('jewelryGiftPromotionItem').getCache('editRowModels');
                for (let i = 0; i < editRowModels.length; i++) {
                    displayitemtype(editRowModels[i], i, true);
                    controlDecimal(editRowModels[i]);
                    displayCapping(editRowModels, i);
                }
            });

            viewmodel.on('beforeDeleteRow', function (args) {
                let jewelryGiftPromotionItem = viewmodel.get('jewelryGiftPromotionItem').getRows();
                if (jewelryGiftPromotionItem && jewelryGiftPromotionItem.length == 1 && args.params.params.cItemName == 'btnDeleteRow3') {
                    cb.utils.alert("只有一个分组无法删除");
                    return false;
                }
            })

            viewmodel.on("modeChange", function (data) {
                mode = data;
                if (data == "browse") {
                    common.displaySonBtn(viewmodel, 'jewelryGiftPromotionItem');
                } else {
                    let editRowModels = viewmodel.get('jewelryGiftPromotionItem').getCache('editRowModels');
                    for (let i = 0; i < editRowModels.length; i++) {
                        editRowModels[i].get('btnAddRow3').setVisible(true);
                        editRowModels[i].get('btnDeleteRow3').setVisible(true);
                        common.displayChannel(viewmodel, 'jewelrygiftpromotion');
                    }
                }
            })

            viewmodel.on('afterMovenext', function (data) {
                common.displaySonBtn(viewmodel, 'jewelryGiftPromotionItem');
            })

            viewmodel.on('afterMoveprev', function (data) {
                common.displaySonBtn(viewmodel, 'jewelryGiftPromotionItem');
            })

            viewmodel.on('afterLoadData', function (data) {
                let editRowModels = viewmodel.get('jewelryGiftPromotionItem').getCache('editRowModels');
                if (mode === 'add') {
                    // viewmodel.get('jewelryGiftPromotionItem').appendRow({});
                } else if (mode === 'edit' || mode === 'browse') {
                    for (let i = 0; i < editRowModels.length; i++) {
                        displayitemtype(editRowModels[i], i, true);
                        controlDecimal(editRowModels[i]);
                        displayCapping(editRowModels, i);
                        if (viewmodel.get('iPromotionalType').getValue() == 1) {
                            let auditStatusModel = editRowModels[i].get('itemtype');
                            let newSource = [];
                            iTemtypeArray && iTemtypeArray.forEach(data => {
                                if (data.value == 1 || data.value == 6 || data.value == 7 || data.value == 8 || data.value == 9) {
                                    newSource.push({value: data.value, nameType: 'text', text: data.text});
                                }
                            });
                            auditStatusModel.setDataSource(newSource);
                        }
                    }
                }
                displayApplyStoreType();
                displayMemberLevelAll();
                displayiActivityRange(false);
                displayisShare();
                common.displayChannel(viewmodel, 'jewelrygiftpromotion');
            });

            //清除全部商品
            viewmodel.on('batchProDelete', function (args) {
                delPro();
            })

            //保存前数据处理
            viewmodel.on('beforeSave', function (data) {

                var obj = JSON.parse(data.data.data);
                obj.terminalType = setCheckBoxEnum(obj.terminalType);

                if (this.get('iMemberLevelAll').getValue() == '0' && this.get('jewelryGiftPromotionMemberLevel').getShowValue() == '') {
                    cb.utils.alert('指定会员不可为空', 'warning');
                    return false;
                } else if (this.get('iMemberLevelAll').getValue() != '0') {
                    obj.jewelryGiftPromotionMemberLevel = [];
                }

                if (this.get('iApplyStoreType').getValue() != '1' && this.get('jewelryGiftPromotionStore').getShowValue() == '') {
                    cb.utils.alert('指定门店不可为空', 'warning');
                    return false;
                } else if (this.get('iApplyStoreType').getValue() == '1') {
                    obj.jewelryGiftPromotionStore = [];
                }
                // if (mode == 'add') {
                //     if (viewmodel.get('cStartTime').getValue() <= nowDates) {
                //         cb.utils.alert('开始时间大于当前时间', 'warning');
                //         return false;
                //     }
                // }

                if (this.get('cStartTime').getValue() >= this.get('cEndTime').getValue()) {
                    cb.utils.alert('活动结束时间必须大于开始时间', 'warning');
                    return false;
                }

                if (obj.iActivityRange == '1') {
                    if (obj.iActiveiDimension == 1) {
                        if (!viewmodel.get('jeweActiveProductClass').getShowValue() || viewmodel.get('jeweActiveProductClass').getShowValue().length == 0) {
                            cb.utils.alert('请选择相应的分类信息', 'warning');
                            return false;
                        }
                    } else if (obj.iActiveiDimension == 2) {
                        if (viewmodel.get('jewelryGiftProduct').getRows() == '') {
                            cb.utils.alert('请选择相应的商品信息', 'warning');
                            return false;
                        }
                        if (obj.jewelryGiftProduct) {
                            for (let i = 0; i < obj.jewelryGiftProduct.length; i++) {
                                obj.jewelryGiftProduct[i].iskuId = 0;
                            }
                        }
                    } else if (obj.iActiveiDimension == 3) {
                        if (viewmodel.get('jewelryGiftProduct').getRows() == '') {
                            cb.utils.alert('请选择相应的商品SKU信息', 'warning');
                            return false;
                        }
                    } else {
                        if (!viewmodel.get('jewelryProductTag').getShowValue() || viewmodel.get('jewelryProductTag').getShowValue().length == 0) {
                            cb.utils.alert('请选择相应的标签信息', 'warning');
                            return false;
                        }
                    }
                }

                for (var i = 0; i < viewmodel.get('jewelryGiftPromotionItem').getRows().length; i++) {
                    let jewelryItem = viewmodel.get('jewelryGiftPromotionItem').getRows()[i];
                    if (jewelryItem.consumerSpending == 0 && jewelryItem.consumerPrice == 0) {
                        cb.utils.alert('第' + (i + 1) + '行的消费满价额度和满克额度不能全为0', 'warning');
                        return false;
                    }
                    if (jewelryItem.itemtype == 1 || jewelryItem.itemtype == 2) {
                        if (jewelryItem.pointstype == 1) {
                            if (!jewelryItem.fireNum || jewelryItem.fireNum == '0') {
                                cb.utils.alert('第' + (i + 1) + '行的减价不可为0或空', 'warning');
                                return false;
                            }
                        } else {
                            if (!jewelryItem.discountNum || jewelryItem.discountNum == '0') {
                                cb.utils.alert('第' + (i + 1) + '行的扣不可为0或空', 'warning');
                                return false;
                            }
                        }
                    } else if (jewelryItem.itemtype == 3) {
                        if (!jewelryItem.goldg || jewelryItem.goldg == '0') {
                            cb.utils.alert('第' + (i + 1) + '行的优惠克数不可为0或空', 'warning');
                            return false;
                        }
                        if (jewelryItem.pointstype == 1) {
                            if (!jewelryItem.fireNum || jewelryItem.fireNum == '0') {
                                cb.utils.alert('第' + (i + 1) + '行的减价不可为0或空', 'warning');
                                return false;
                            }
                        } else if (jewelryItem.pointstype == 2) {
                            if (!jewelryItem.discountNum || jewelryItem.discountNum == '0') {
                                cb.utils.alert('第' + (i + 1) + '行的折扣不可为0或空', 'warning');
                                return false;
                            }
                        } else if (jewelryItem.pointstype == 3) {
                            if (!jewelryItem.givenum || jewelryItem.givenum == '0') {
                                cb.utils.alert('第' + (i + 1) + '行的一口价不可为0或空', 'warning');
                                return false;
                            }
                        }
                    } else if (jewelryItem.itemtype == 5) {
                        if (!jewelryItem.addprice || jewelryItem.addprice == '0') {
                            cb.utils.alert('第' + (i + 1) + '行的加价数不可为0或空', 'warning');
                            return false;
                        }
                        if (!jewelryItem.givenum || jewelryItem.givenum == '0') {
                            cb.utils.alert('送工费不可为0或空', 'warning');
                            return false;
                        }
                    } else if (jewelryItem.itemtype == 6 || jewelryItem.itemtype == 7) {
                        if (!jewelryItem.addprice || jewelryItem.addprice == '0') {
                            cb.utils.alert('第' + (i + 1) + '行的加价数不可为0或空', 'warning');
                            return false;
                        }
                        if (!jewelryItem.givenum || jewelryItem.givenum == '0') {
                            cb.utils.alert('第' + (i + 1) + '行的赠送数不可为0或空', 'warning');
                            return false;
                        }
                        if (jewelryItem.pointstype != 1 && jewelryItem.pointstype != 2) {
                            if (!jewelryItem.cGiftNames) {
                                cb.utils.alert('第' + (i + 1) + '行的赠送名称不可为空', 'warning');
                                return false;
                            }
                        }
                    } else if (jewelryItem.itemtype == 8) {
                        if (!jewelryItem.givenum || jewelryItem.givenum == '0') {
                            cb.utils.alert('第' + (i + 1) + '行的积分不可为0或空', 'warning');
                            return false;
                        }
                    } else if (jewelryItem.itemtype == 9) {
                        if (!jewelryItem.givenum || jewelryItem.givenum == '0') {
                            cb.utils.alert('第' + (i + 1) + '行的优惠券张数不可为0或空', 'warning');
                            return false;
                        }
                    }


                }

                data.data.data = JSON.stringify(obj);
            });
        }
    };
    try {
        module.exports = PM_pmc_jewelrygiftpromotion_VM_Extend;
    } catch (error) {

    }
    return PM_pmc_jewelrygiftpromotion_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/PM/PM_pmc_jewelrygiftpromotion_VM.Extend.js